import angular from 'angular';
import { get } from 'lodash';
import moment from 'moment-timezone';

const module = angular.module('whyline.modals.entry-info', []);

const EntryInfoController = ($scope, $uibModalInstance, entry, modalInfoFromServer) => {
  'ngInject';

  $scope.entry = entry;
  $scope.modalInfoFromServer = modalInfoFromServer;

  // Close modal
  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.getAlias = () => $scope.entry.alias.join(' ');

  $scope.getName = () => {
    const firstName = get($scope, 'entry.person.firstName', '');
    const lastNameName = get($scope, 'entry.person.lastName', '');

    return `${firstName} ${lastNameName}`;
  };

  $scope.getPhone = () => get($scope, 'entry.person.phone.full', '');

  $scope.getAmountOfPeopleAhead = () => get($scope, 'modalInfoFromServer.amountOfPeopleAHead', 0);

  $scope.parseDiffDate = (date) => {
    if (!date) {
      return null;
    }

    const parsedDate = new Date(date).toISOString();
    const time = moment(parsedDate);
    const now = moment(new Date().toISOString());
    const timeDiff = now.diff(time);
    const result = moment.duration(timeDiff);
    const minutes = parseTimeNumber(result.minutes());
    const hours = parseTimeNumber(result.hours());

    return `${hours}:${minutes}`;
  };

  $scope.showTimers = () => {
    if ($scope.entry.status !== 'waiting') {
      return false;
    }

    if (!entry.checkedInTime && !$scope.showLastCall()) {
      return false;
    }

    return true;
  };

  $scope.showConfirmedTime = () => !!entry.checkedInTime;

  $scope.showCanceledBy = () => {
    if ($scope.entry.status !== 'canceled') {
      return false;
    }
    return true;
  };

  $scope.parseReason = () => {
    const reason = get($scope, 'entry.reason', '');

    let result = '';

    switch (reason) {
      case 'not-present':
        result = 'receptionist';
        break;
      case 'cancel-by-user':
        result = 'user information';
        break;
      case 'daily-reset':
        result = 'system';
        break;
    }

    return result;
  };

  $scope.showLastCall = () => {
    const itsYourTurn = get($scope, 'entry.notifications.itsYourTurn', false);

    if (!itsYourTurn || typeof itsYourTurn === 'boolean') {
      return false;
    }
    return true;
  };

  const parseTimeNumber = (number) => {
    if (!number || number <= 0) {
      return '00';
    }

    const stringNumber = String(number);

    if (stringNumber.length > 1) {
      return stringNumber;
    }

    return `0${stringNumber}`;
  };
};

module.exports = module.controller('EntryInfoController', EntryInfoController);
